import React from "react";
import clsx from "clsx";
import {
  DialogTrigger,
  Modal,
  Dialog,
  ModalOverlay,
  DialogRenderProps,
} from "react-aria-components";

import Button, { ButtonProps } from "../forms/button";

import styles from "./sidebar-overlay.module.css";

interface SidebarOverlayProps {
  trigger: ButtonProps;
  children:
    | ((dialogRenderProps: DialogRenderProps) => React.ReactNode)
    | React.ReactNode;
  header:
    | ((dialogRenderProps: DialogRenderProps) => React.ReactNode)
    | React.ReactNode;
}

function SidebarOverlay({ trigger, children, header }: SidebarOverlayProps) {
  return (
    <DialogTrigger>
      <Button {...trigger} />
      <ModalOverlay
        isDismissable={true}
        className={styles.modalOverlay}
        shouldCloseOnInteractOutside={() => {
          return true;
        }}
      >
        <Modal
          className={({ isEntering }) =>
            clsx(styles.sidebar, { [styles.loading]: isEntering })
          }
        >
          <Dialog className={styles.dialog}>
            {(actions) => (
              <div className={styles.inner}>
                <div className={styles.header}>
                  <div>
                    {typeof header === "function" ? header(actions) : header}
                  </div>
                  <Button
                    aria-label="Close"
                    slot="close"
                    variant="tertiary"
                    icon={{ type: "x" }}
                  />
                </div>
                {typeof children === "function" ? children(actions) : children}
              </div>
            )}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
}

export default SidebarOverlay;
